export default "__VITE_ASSET__BGOEUr6r__"